"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateUrl = exports.getLanguage = void 0;
/**
 * This is your main. This is where you re-export everything you want to be publicly available.
 *
 * The build enforces that the file has the same name as the global variable that is exported.
 */
function getLanguage(language) {
    if (language === undefined) {
        return 'en-us';
    }
    var lowerLang = language.toLocaleLowerCase();
    var retval;
    if (lowerLang.length > 2 && lowerLang.includes('_')) {
        retval = lowerLang.replace('_', '-');
    }
    else if (lowerLang === 'en') {
        retval = 'en-us';
    }
    else if (lowerLang === 'de') {
        retval = 'de-de';
    }
    else if (lowerLang === 'es') {
        retval = 'es-es';
    }
    else if (lowerLang === 'fr') {
        retval = 'fr-fr';
    }
    else if (lowerLang === 'it') {
        retval = 'it-it';
    }
    else if (lowerLang === 'ja') {
        retval = 'ja-jp';
    }
    else if (lowerLang === 'ko') {
        retval = 'ko-kr';
    }
    else if (lowerLang === 'pt') {
        retval = 'pt-br';
    }
    else if (lowerLang === 'zh') {
        retval = 'zh-cn';
    }
    else {
        retval = 'en-us';
    }
    return retval;
}
exports.getLanguage = getLanguage;
function generateUrl(langauge, edition, version, category, platform, build) {
    var retval = 'https://www.tableau.com/';
    var prepStr = 'prep';
    var phoenixStr = 'tableau-mobile-phoenix';
    if (edition === phoenixStr) {
        retval += langauge += '/app/' + category + '?edition=' + edition + '&lang=' + langauge + '&version=' + version;
    }
    else if (edition === prepStr) {
        retval +=
            langauge +
                '/app/' +
                category +
                '?build=' +
                build +
                '&edition=' +
                edition +
                '&lang=' +
                langauge +
                '&platform=' +
                platform +
                '&version=' +
                version;
    }
    else if (category.includes('server') || category.includes('online')) {
        retval += langauge + '/app/' + category + '?edition=' + edition + '&lang=' + langauge + '&platform=' + platform + '&version=' + version;
    }
    return retval;
}
exports.generateUrl = generateUrl;
//# sourceMappingURL=HelpLinkLibrary.js.map